import { annualTop } from "@/mocks/ranking";

const metricLabel: Record<string, string> = {
  heat: "热度",
  reversal: "反转",
  scope: "影响",
};

export default function AnnualRanking() {
  return (
    <section id="annual" className="mx-auto w-full max-w-7xl scroll-mt-16 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-bold tracking-widest text-primary-700">
            <i className="ri-trophy-fill"></i>
            2026 年度
          </span>
          <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            年度最劲爆瓜榜 · TOP 10
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            综合全年讨论量、剧情反转次数与跨平台影响广度加权得出。排名越靠前，说明这个瓜“越香越劲爆”。
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden text-xs font-medium text-foreground-500 sm:inline">更新时间</span>
          <span className="rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-semibold text-foreground-700">
            2026.09.06 · 第 12 期
          </span>
        </div>
      </div>

      <div className="mt-8 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
        <ol className="divide-y divide-background-200/80">
          {annualTop.map((item) => (
            <li key={item.rank} className="group bg-background-50">
              <div className="flex flex-col gap-4 px-5 py-5 md:flex-row md:items-center md:px-7">
                <div className="flex items-center gap-4 md:w-16 md:shrink-0 md:flex-col md:gap-0">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-serif text-xl font-black ${
                      item.rank === 1
                        ? "bg-primary-500 text-background-50 pulse-hot"
                        : item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : item.rank <= 6
                            ? "bg-accent-500 text-background-50"
                            : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-serif text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                      {item.title}
                    </h3>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 hidden gap-6 md:flex">
                    {(["heat", "reversal", "scope"] as const).map((key) => (
                      <div key={key} className="flex items-center gap-2">
                        <span className="text-xs font-medium text-foreground-500">
                          {metricLabel[key]}
                        </span>
                        <span className="h-1.5 w-20 overflow-hidden rounded-full bg-background-200">
                          <span
                            className={`block h-full rounded-full ${
                              key === "heat"
                                ? "bg-primary-500"
                                : key === "reversal"
                                  ? "bg-accent-500"
                                  : "bg-secondary-500"
                            }`}
                            style={{ width: `${item[key]}%` }}
                          ></span>
                        </span>
                        <span className="text-xs font-bold text-foreground-800">
                          {item[key]}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex shrink-0 items-center gap-1 text-sm font-bold text-primary-600">
                  <i className="ri-fire-fill"></i>
                  {item.heat}%
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <p className="mt-4 text-xs leading-relaxed text-foreground-400">
        * 榜单由站方按公开讨论热度、剧情反转与传播广度综合整理，仅作话题盘点用途，不代表对任何个人或机构的定性与评价。
      </p>
    </section>
  );
}